import React, { useState } from 'react';
import AppLayout from '../components/layout/AppLayout';
import DashboardContent from '../components/DashboardContent';
import useShipments from '../hooks/useShipments';

export default function Dashboard() {
  const { shipments, loading, reload } = useShipments();
  const [scope3RefreshTick, setScope3RefreshTick] = useState(0);

  return (
    <AppLayout title="Dashboard">
      <div className="max-w-7xl mx-auto">
        <DashboardContent
          shipments={shipments}
          onShipmentsChange={reload}
          loadingShipments={loading}
          scope3RefreshTick={scope3RefreshTick}
          onScope3Changed={() => setScope3RefreshTick((t) => t + 1)}
        />
      </div>
    </AppLayout>
  );
}
